/* global store ENVIRONMENT */
/* global IS_PREVIEW_PAGE */

import { visibilityChangeEvent } from 'Renderer/domOperations/adOperations';

export const isNestedIframe = () => {
  try {
    return window.frameElement.parentNode.ownerDocument.defaultView !== window.top;
  } catch (e) {
    return false;
  }
};

export const getNestedWindow = () => {
  try {
    const isKargoPreview = frameElement.closest('.krg-preview');
    if (isKargoPreview) return window;
    return window.frameElement.parentNode.ownerDocument.defaultView;
  } catch (e) {
    return window;
  }
};

export const initialiseAdDimensions = (rootElement) => {
  const thisWindow = window;
  const frame = thisWindow.frameElement;
  const noWidth = (frame.clientWidth === 0);
  const noHeight = (frame.clientHeight === 0);
  if (noWidth) frame.style.width = '2px';
  if (noHeight) frame.style.height = '2px';

  let element = rootElement;
  let lastElement = rootElement;
  let style = element.style || {};

  while (element.parentNode) {
    lastElement = element;
    element = element.parentNode;

    if (typeof element === 'undefined' || element === null || element.nodeName === 'BODY') {
      break;
    }

    style = element.style;
    style = style || {};
    style.width = '100%';
    style.height = '100%';
    style['max-width'] = 'none';
    style['max-height'] = 'none';
  }

  return lastElement;
};

export const resizeIframe = (artboard, eventType) => {
  const { activeArtboard, mraid } = store.getState();

  if (mraid) {
    if (eventType === 'expand') {
      const screenSize = mraid.getScreenSize();
      mraid.setExpandProperties({
        width: screenSize.width,
        height: screenSize.height,
        useCustomClose: true,
      });
      mraid.expand();
    } else if (eventType === 'expand-close' || eventType === 'close') {
      mraid.close();
    }
  } else {
    const thisWindow = window;
    const frame = thisWindow.frameElement;
    const adjustablePercentage = frame.clientWidth / activeArtboard.viewport.width;
    const adjustedViewportWidth = artboard.viewport.width * adjustablePercentage;
    const adjustedViewportHeight = artboard.viewport.height * adjustablePercentage;
    const frameParent = thisWindow.frameElement.parentNode;
    const frameGeometry = frame.getBoundingClientRect();

    if (eventType === 'expand-close' || eventType === 'close') {
      frame.parentNode.style.transition = 'none';
    } else {
      frame.parentNode.parentNode.style.margin = 'auto';
      frame.parentNode.parentNode.style.overflow = 'visible';
    }

    let expandDirection = 'down';

    if (eventType === 'expand') frame.parentNode.style.transition = 'all ease-out 0.5s';

    if (eventType === 'expand' || eventType === 'switch-artboard') {
      const windowCentre = {};
      windowCentre.x = window.top.innerWidth / 2;
      windowCentre.y = window.top.innerWidth / 2;
      if ((frameGeometry.x > windowCentre.x) && (frameGeometry.width < adjustedViewportWidth)) {
        expandDirection = 'left';
      } else if ((frameGeometry.y > windowCentre.y) && (frameGeometry.height < adjustedViewportHeight)) {
        expandDirection = 'up';
      }
    } else if (eventType === 'expand-close' || eventType === 'close') {
      expandDirection = 'close';
    }

    frame.style.width = `${adjustedViewportWidth}px`;
    frame.width = `${adjustedViewportWidth}px`;
    frame.style.height = `${adjustedViewportHeight}px`;
    frame.height = `${adjustedViewportHeight}px`;

    frame.parentNode.style.width = `${adjustedViewportWidth}px`;
    frame.parentNode.style.maxWidth = `${adjustedViewportWidth}px`;
    frame.parentNode.width = `${adjustedViewportWidth}px`;
    frame.parentNode.style.height = `${adjustedViewportHeight}px`;
    frame.parentNode.style.maxHeight = `${adjustedViewportHeight}px`;
    frame.parentNode.height = `${adjustedViewportHeight}px`;

    frame.style.zIndex = '2';
    frameParent.style.zIndex = '2';
    frameParent.parentNode.style.height = 'auto';
    frameParent.parentNode.style.maxHeight = '';

    if (expandDirection === 'left') {
      frame.parentNode.style.marginLeft = `-${adjustedViewportWidth / 2}px`;
    } else if (expandDirection === 'up') {
      const calculatedMargin = frameGeometry.height - adjustedViewportHeight;
      frame.parentNode.style.marginTop = `${calculatedMargin}px`;
    } else if (expandDirection === 'close') {
      frame.parentNode.style.marginLeft = 'auto';
      frame.parentNode.style.marginTop = 'auto';
    }
  }
};

export const setupPushdown = () => {
  const thisWindow = window;
  const frame = thisWindow.frameElement;
  const frameParent = thisWindow.frameElement.parentNode;
  frameParent.style.overflow = 'hidden';
  frameParent.style.height = '0px';
  frame.style.height = '250px';
  frame.parentNode.parentNode.style.height = 'auto';
  frame.parentNode.parentNode.style.maxHeight = '';
};

export const resizePushdown = (artboard) => {
  const { rootElement } = store.getState();
  const thisWindow = window;
  const frame = thisWindow.frameElement ? thisWindow.frameElement : rootElement.parentNode;
  const adjustablePercentage = frame.clientWidth / artboard.viewport.width;
  frame.style.height = `${artboard.viewport.height * adjustablePercentage}px`;
  frame.parentNode.style.height = `${artboard.viewport.height * adjustablePercentage}px`;
};

export const pushdownIframe = (artboard, eventType = '') => {
  const { canAccessIframe } = store.getState();
  const isClose = (eventType === 'close') || (eventType === 'expand-close');
  const thisWindow = window;
  const frame = thisWindow.frameElement;
  frame.style.transition = 'all ease-out 0.5s';
  const currentHeight = frame.getBoundingClientRect().height;
  const adjustablePercentage = frame.clientWidth / artboard.viewport.width;
  const adjustedHeight = artboard.viewport.height * adjustablePercentage;
  frame.parentNode.style.transition = 'height 1s';
  frame.style.height = `${adjustedHeight}px`;
  setTimeout(() => {
    visibilityChangeEvent();
    frame.parentNode.style.height = `${artboard.viewport.height * adjustablePercentage}px`;
    frame.parentNode.setAttribute('data-visible', 'true');
  }, 800);
  if (IS_PREVIEW_PAGE && canAccessIframe) {
    const siteBackground = window.top.document.querySelector('.site-background div');
    siteBackground.style.transition = 'all ease-out 0.5s';
    if (isClose) {
      siteBackground.style.marginTop = 0;
    } else {
      siteBackground.style.marginTop = `${adjustedHeight - currentHeight}px`;
    }
  }
};

export const collapseIframe = () => {
  const thisWindow = window;
  const frame = thisWindow.frameElement;

  frame.display = 'block';
  frame.style.width = '100%';
  frame.width = '100%';
  frame.style.height = '0px';
  frame.height = '0px';

  frame.parentNode.style.height = 'auto';
  frame.parentNode.parentNode.style.height = 'auto';
  frame.parentNode.parentNode.parentNode.style.height = 'auto';
};

export const setupExpandableFrame = (formatName) => {
  const thisWindow = window;
  const frame = thisWindow.frameElement;
  const frameParent = thisWindow.frameElement.parentNode;

  frame.style.display = 'block';
  frame.style.position = 'relative';
  frame.parentNode.style.display = 'block';
  frame.parentNode.style.overflow = 'hidden';
  // frame.parentNode.style.transition = 'width 1s, height 1s, margin-left 1s, margin-top 1s';
  frame.parentNode.parentNode.parentNode.style.display = 'block';

  if (formatName.toLowerCase() === 'expand') {
    frameParent.style.minHeight = `${frame.height}px`;
    frameParent.style.maxHeight = `${frame.height}px`;
  }
};

export const setupIframeBody = (iframe, domIdentifer) => {
  const html = `<body style='margin:0px;height:100%;width:100%; overflow:hidden;'><div id='${domIdentifer}'></div></body>`;

  iframe.contentWindow.document.open(); // eslint-disable-line no-undef
  iframe.contentWindow.document.write(html); // eslint-disable-line no-undef
  iframe.contentWindow.document.close(); // eslint-disable-line no-undef
};

export const getElement = (container, selector) => {
  const domcontainer = container;
  if (domcontainer) return domcontainer.querySelector(selector);
  return null;
};



// WEBPACK FOOTER //
// ./app/javascript/renderer/domOperations/iFrameOperations.js